<template>
  <component
    class="Btn"
    :is="tagName"
    :href="props.link"
    :target="props.target"
    :class="`Btn--${props.type}`"
    :style="btnStyles"
    :disabled="disabled"
    type="button"
  >

    <p class="Btn__txt" :style="opacityValue">
      <slot />
    </p>
    <LoaderCircle class="Btn__ldr" v-if="props.loading"/>
  </component>
</template>

<script setup>
  import { computed } from 'vue';
  import { Props } from './props.js';
  //--------------------------
  import LoaderCircle from '@ui/Loaders/LoaderCircle/LoaderCircle';
  //--------------------------
  const props = defineProps(Props());
  //--------------------------
  //Получаем стили кнопки
  const btnStyles = computed(() => ({
    width: props.width || undefined,
    maxHeight: props.height || undefined,
    minHeight: props.height || undefined,
    borderRadius: props.radius || undefined,
    padding: props.padding || undefined
  }))
  //Определяем тип тега (button или a)
  const tagName = computed(() => props.link ? 'a' : 'button');
  //Получаем текущее значение прозрачности контентной части кнопки
  const opacityValue = computed(() => props.loading ? 'opacity: 0' : '');
</script>

<style scoped lang="scss">
  @import './styles/_base.scss';
</style>
